/*
  Hub Eatery collection page behaviour, matching the prototype's Menu tab:
  - dietary filter pills, multi-select AND, built from dietaries_* tags
  - lunch sub-category pills (all / salads / hot food / sushi)
  - per-card size-variant <select> with live price
  - cart controls: an always-visible quantity capsule ([−] qty [+]) that sets the
    DESIRED quantity before adding — floored at custom.min_order, never below —
    plus a solid ADD button that commits that quantity in one /cart/add.js call.
    ADD is additive, so a second ADD adds again; the button flashes "added ✓" and
    the header cart count updates on success.
*/
(function () {
  var root = document.querySelector('[data-hub-collection]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var activeDiet = {};
  var subGroup = 'all';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function cards() {
    return Array.prototype.slice.call(root.querySelectorAll('.hub-prod'));
  }

  /* ---- filtering ---- */
  function applyFilters() {
    var wanted = Object.keys(activeDiet).filter(function (k) { return activeDiet[k]; });
    var shown = 0;
    cards().forEach(function (card) {
      var diet = (card.getAttribute('data-dietary') || '').split(' ');
      var group = card.getAttribute('data-group') || '';
      var dietOk = wanted.every(function (k) { return diet.indexOf(k) !== -1; });
      var groupOk = subGroup === 'all' || group === subGroup;
      var show = dietOk && groupOk;
      card.hidden = !show;
      if (show) shown++;
    });
    var empty = root.querySelector('[data-hub-empty]');
    if (empty) empty.hidden = shown !== 0;
    var clear = root.querySelector('[data-hub-clear]');
    if (clear) clear.hidden = wanted.length === 0;
  }

  root.querySelectorAll('[data-diet]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var k = pill.getAttribute('data-diet');
      activeDiet[k] = !activeDiet[k];
      pill.setAttribute('aria-pressed', activeDiet[k] ? 'true' : 'false');
      applyFilters();
    });
  });

  root.querySelectorAll('[data-sub]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      subGroup = pill.getAttribute('data-sub');
      root.querySelectorAll('[data-sub]').forEach(function (p) {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      applyFilters();
    });
  });

  var clearBtn = root.querySelector('[data-hub-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      activeDiet = {};
      root.querySelectorAll('[data-diet]').forEach(function (p) {
        p.setAttribute('aria-pressed', 'false');
      });
      applyFilters();
    });
  }

  /* ---- variant selection ---- */
  function selectedVariant(card) {
    var sel = card.querySelector('.hub-prod__variant');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return { id: opt.getAttribute('data-vid'), price: parseInt(opt.getAttribute('data-price'), 10) };
    }
    return {
      id: card.getAttribute('data-vid'),
      price: parseInt(card.getAttribute('data-price'), 10)
    };
  }

  function refreshPrice(card) {
    var v = selectedVariant(card);
    var priceEl = card.querySelector('.hub-prod__price');
    if (priceEl) priceEl.textContent = formatMoney(v.price);
  }

  cards().forEach(function (card) {
    var sel = card.querySelector('.hub-prod__variant');
    if (sel) {
      sel.addEventListener('change', function () {
        refreshPrice(card);
      });
    }
  });

  /* ---- quantity capsule: the DESIRED quantity, floored at the min ---- */
  function minOf(card) {
    return parseInt(card.getAttribute('data-min'), 10) || 1;
  }

  function qtyNode(card) {
    return card.querySelector('[data-hub-qtyn]');
  }

  function getQty(card) {
    var n = qtyNode(card);
    return n ? (parseInt(n.textContent, 10) || minOf(card)) : minOf(card);
  }

  function setQty(card, q) {
    var min = minOf(card);
    if (q < min) q = min;
    var n = qtyNode(card);
    if (n) n.textContent = q;
    var dec = card.querySelector('[data-act="dec"]');
    if (dec) dec.disabled = q <= min; // cannot go below the minimum
  }

  cards().forEach(function (card) {
    var dec = card.querySelector('[data-act="dec"]');
    var inc = card.querySelector('[data-act="inc"]');
    var add = card.querySelector('[data-hub-add]');
    if (dec) dec.addEventListener('click', function () { setQty(card, getQty(card) - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(card, getQty(card) + 1); });
    if (add) add.addEventListener('click', function () { addToCart(card, add); });
  });

  /* ---- header cart count ---- */
  function setBubble(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var span = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
      if (span) span.textContent = count;
      b.classList.toggle('hub-cart-empty', count === 0);
    });
    document.querySelectorAll('[data-hub-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  }

  function syncCart() {
    return fetch(routesRoot() + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBubble(cart.item_count); return cart; });
  }

  /* ---- add: commit the capsule quantity in one action (additive) ---- */
  var busy = false;
  function addToCart(card, btn) {
    if (busy) return;
    busy = true;
    var v = selectedVariant(card);
    var qty = getQty(card);
    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return syncCart(); })
      .then(function () {
        confirmAdded(btn);
        // open the view-only drawer (no-op if it isn't on the page)
        document.dispatchEvent(new CustomEvent('hub:cart:added', { detail: { trigger: btn } }));
      })
      .catch(function () { /* leave the button untouched so the user can retry */ })
      .then(function () { busy = false; });
  }

  function confirmAdded(btn) {
    btn.classList.add('is-added');
    btn.disabled = true;
    btn.textContent = 'added ✓';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.disabled = false;
      btn.textContent = 'add';
    }, 1400);
  }

  applyFilters();
  syncCart();
})();
